import * as React from 'react';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';

import Retracked from 'js/app/retracked';

type ImplProps = TrackedOnLinkClickWrapperProps &
  React.PropsWithChildren<{
    elementType: 'div' | 'span';
  }>;

class TrackedOnLinkClickImpl extends React.Component<ImplProps> {
  static contextTypes = {
    _eventData: PropTypes.object,
    _withTrackingData: PropTypes.func,
  };

  declare context: LegacyContextType<typeof TrackedOnLinkClickImpl.contextTypes>;

  trackClick = (e: $TSFixMe) => {
    if (e.target.tagName === 'A') {
      const { _eventData, _withTrackingData } = this.context;
      const { dataFromEvent, data, trackingName, clickHandler } = this.props;
      // some links might have a click event instead of the href attribute
      const { href } = e.target.attributes;
      Retracked.trackComponent(
        _eventData,
        {
          ...data,
          ...(dataFromEvent ? dataFromEvent(e) : {}),
          href: href && href.value,
        },
        trackingName,
        'click',
        _withTrackingData
      );

      if (clickHandler) {
        clickHandler(e);
      }
    }
  };

  render() {
    const { _eventData } = this.context;
    const { children, clickHandler, data, dataFromEvent, elementType, trackingName, ...rest } = this.props;
    const namespace = (_eventData && _eventData.namespace) || {};
    const action = 'click';
    const { app, page } = namespace;
    const component = trackingName;
    const Element = elementType;

    return (
      <Element
        {...rest}
        onClick={this.trackClick}
        data-track={true}
        data-track-app={app}
        data-track-page={page}
        data-track-action={action}
        data-track-component={component}
      >
        {children}
      </Element>
    );
  }
}

// Props are typed to accept the tracking-specific props plus any standard
// div/span DOM attributes (className, style, etc.) that callers pass through.
type TrackedOnLinkClickWrapperProps = Omit<React.HTMLAttributes<HTMLDivElement | HTMLSpanElement>, 'onClick'> & {
  clickHandler?: (event: React.MouseEvent<HTMLDivElement | HTMLSpanElement>) => void;
  data?: Record<string, unknown>;
  dataFromEvent?: (e: React.MouseEvent<HTMLDivElement | HTMLSpanElement>) => Record<string, unknown>;
  trackingName: string;
};

export const TrackedOnLinkClickDiv = (props: TrackedOnLinkClickWrapperProps) => {
  return <TrackedOnLinkClickImpl elementType={'div' as const} {...props} />;
};

export const TrackedOnLinkClickSpan = (props: TrackedOnLinkClickWrapperProps) => {
  return <TrackedOnLinkClickImpl elementType={'span' as const} {...props} />;
};
